export const integrations = {
	integrations: "Integrations",
	integrationsDescription:
		"Access operation data via Zig API: store, sales, fiscal, bonuses, recharges and more.",
	createDrawer: {
		addPlaces: "Link places",
		addPlacesDescription: "Select the places you want to link to this token.",
		selectPlaces: "Select places",
		selectAll: "Select all",
		generateTokenMessage:
			"This token will be generated and linked to all selected places ({{count}}). It can be used to authenticate integrations with the Zig API only in these places. Do you want to continue?",
		generateTokenConfirm: "Generate token and link to places",
		cancelTokenMessage:
			"By canceling, the token will not be created and the place selection will be discarded. Do you want to continue anyway?",
		cancelToken: "Cancel token",
	},
	token: "Token",
	createToken: "Generate Token",
	techDocumentation: "Technical documentation",
	searchPlaceholder: "Search by place ID",
	noContentTitle: "Nothing here yet",
	noContentDescription:
		"Generate a token to integrate external systems with the Zig API. Copy and use it for authentication.",
	noDataTitle: "We couldn't find what you're looking for",
	noDataDescription: "The place was not found.",
	generatedBy: "Generated by | ",
	generatedByDate: " on ",
	generatedByTime: " at ",
	viewLinkedPlaces: "View linked places",
	linkedPlaces: "Linked places",
	copyToken: "Copy token",
	copyTokenButtonSuccess: "Copied",
	copyTokenTooltip: "Copy complete token for API authentication",
	copyTokenSuccess: "The token code has been copied to clipboard",
	deleteToken: "Delete token",
	deleteTokenConfirm: "Delete token",
	deleteTokenConfirmMessage:
		"By deleting this token, it may affect ongoing integrations of all places linked to it. Do you want to continue anyway?",
	successCreateToken: "Token created successfully",
	successDeleteToken: "Token deleted successfully",
	alertTitle:
		"This token grants full access to the Zig API. Use only in secure integrations.",
	alertDescription: "Once created, it will remain active until deleted.",
	tokenListTitle: "API Token",
	orgInfo: "Network | ",
};
